import React from "react";
import VisorPluginPlaceholder from "../../../_visor/components/canvas/VisorPluginPlaceholder";
import QuizStatusLine from "../../../_visor/components/canvas/QuizStatusLine";
import { contentI18n as i18n } from "../../../common/content_language";
import { setRgbaAlpha } from "../../../common/common_tools";
import { correctArrayOrdered, correctFillInBlank } from "../../../core/visor/correction_functions";

/* eslint-disable react/prop-types */

export function FillInBlank() {
  return {
    getRenderTemplate: function (state, props) {
      let content = [];
      let attempted = props.exercises && props.exercises.attempted;
      let score = props.exercises.score || 0;
      score = Math.round(score * 100) / 100;
      score = score + "/" + (props.exercises.weight || 0);
      // Page-wide submit marks every exercise attempted; only show feedback for
      // one the learner actually typed into (at least one non-empty blank).
      let answered =
        Array.isArray(props.exercises.currentAnswer) &&
        props.exercises.currentAnswer.some((v) => v != null && String(v).trim() !== "");
      let showFeedback = attempted && answered && state.showFeedback;

      let istrue =
        attempted &&
        JSON.stringify(props.exercises.correctAnswer).toLocaleUpperCase(i18n.language || "tr") ==
          JSON.stringify(props.exercises.currentAnswer).toLocaleUpperCase(i18n.language || "tr");

      // Tekrar ("Try Again") modunda input'lar yeşil/kırmızı boyanmaz (cevap
      // açığa çıkmasın); sonuç yalnızca buton altındaki durum satırıyla bildirilir.
      const isTryAgainMode =
        state.buttons === "tryAgain" ||
        state.buttons === i18n.t("MultipleChoice.tryAgain") ||
        state.buttons === "Try Again" ||
        state.buttons === "Tekrar Dene";

      let trueFeedbackContainer = props.boxes[props.id].sortableContainers["sc-TrueFeedback"];
      let trueFeedbackToolbar = trueFeedbackContainer?.children?.[0]
        ? props.toolbars[trueFeedbackContainer.children[0]]
        : null;

      let falseFeedbackContainer = props.boxes[props.id].sortableContainers["sc-FalseFeedback"];
      let falseFeedbackToolbar = falseFeedbackContainer?.children?.[0]
        ? props.toolbars[falseFeedbackContainer.children[0]]
        : null;

      let fixImgSvgStructure = (text) => {
        if (!text || typeof text !== "string") return text;
        let decoded = text;
        try {
          if (text.includes("%3C") || text.includes("%3E")) {
            decoded = decodeURIComponent(text);
          }
        } catch (e) {}

        decoded = decoded.replace(
          /<img\s*([^>]*?)>([\s\S]*?)<\/img>/gi,
          (match, attrs, content) => {
            if (content && content.trim() && content.includes("<svg")) {
              let spanAttrs = attrs ? attrs.trim() : "";
              if (spanAttrs && spanAttrs.includes("style=")) {
                spanAttrs = spanAttrs.replace(
                  /style\s*=\s*["']([^"']*)["']/i,
                  (styleMatch, styleContent) => {
                    let cleanStyle = styleContent.trim().replace(/;\s*$/, "");
                    return `style="${cleanStyle};display:inline-block;"`;
                  }
                );
              } else {
                spanAttrs = (spanAttrs ? spanAttrs + " " : "") + 'style="display:inline-block;"';
              }
              return `<span ${spanAttrs}>${content}</span>`;
            }
            return match;
          }
        );
        decoded = decoded.replace(/<img\s*([^>]*?)>\s*<svg/gi, (match, attrs) => {
          let spanAttrs = attrs ? attrs.trim() : "";
          if (spanAttrs && spanAttrs.includes("style=")) {
            spanAttrs = spanAttrs.replace(
              /style\s*=\s*["']([^"']*)["']/i,
              (styleMatch, styleContent) => {
                let cleanStyle = styleContent.trim().replace(/;\s*$/, "");
                return `style="${cleanStyle};display:inline-block;"`;
              }
            );
          } else {
            spanAttrs = (spanAttrs ? spanAttrs + " " : "") + 'style="display:inline-block;"';
          }
          return `<span ${spanAttrs}><svg`;
        });
        decoded = decoded.replace(/<\/svg>[\s\n]*<\/img>/gi, "</svg></span>");
        if (text.includes("%3C") || text.includes("%3E")) {
          try {
            return encodeURIComponent(decoded);
          } catch (e) {
            return decoded;
          }
        }
        return decoded;
      };

      let trueFeedbackText = fixImgSvgStructure(trueFeedbackToolbar?.state?.__text || "");
      let isDefaultTrueFeedbackMsg = false;

      let defaultTrueFeedbackMsg = "<p>" + i18n.t("MultipleChoice.TrueFeedbackMsg") + "</p>";

      if (
        trueFeedbackText === defaultTrueFeedbackMsg ||
        trueFeedbackText === encodeURI(defaultTrueFeedbackMsg) ||
        trueFeedbackText === encodeURI(defaultTrueFeedbackMsg + "\n") ||
        trueFeedbackText.includes(i18n.t("MultipleChoice.TrueFeedbackMsg"))
      ) {
        isDefaultTrueFeedbackMsg = true;
      }

      let checkEmptyTrueFeedback =
        (!trueFeedbackContainer?.children ||
          trueFeedbackContainer.children.length === 0 ||
          trueFeedbackToolbar?.state?.__text === "<p>" + i18n.t("text_here") + "</p>" ||
          trueFeedbackToolbar?.state?.__text === encodeURI("<p>" + i18n.t("text_here") + "</p>") ||
          trueFeedbackToolbar?.state?.__text ===
            encodeURI("<p>" + i18n.t("text_here") + "</p>\n")) &&
        !isDefaultTrueFeedbackMsg;

      let falseFeedbackText = fixImgSvgStructure(falseFeedbackToolbar?.state?.__text || "");
      let isDefaultFalseFeedbackMsg = false;

      let defaultFalseFeedbackMsg = "<p>" + i18n.t("MultipleChoice.FalseFeedbackMsg") + "</p>";

      if (
        falseFeedbackText === defaultFalseFeedbackMsg ||
        falseFeedbackText === encodeURI(defaultFalseFeedbackMsg) ||
        falseFeedbackText === encodeURI(defaultFalseFeedbackMsg + "\n") ||
        falseFeedbackText.includes(i18n.t("MultipleChoice.FalseFeedbackMsg"))
      ) {
        isDefaultFalseFeedbackMsg = true;
      }

      let checkEmptyFalseFeedback =
        (!falseFeedbackContainer?.children ||
          falseFeedbackContainer.children.length === 0 ||
          falseFeedbackToolbar?.state?.__text === "<p>" + i18n.t("text_here") + "</p>" ||
          falseFeedbackToolbar?.state?.__text === encodeURI("<p>" + i18n.t("text_here") + "</p>") ||
          falseFeedbackToolbar?.state?.__text ===
            encodeURI("<p>" + i18n.t("text_here") + "</p>\n")) &&
        !isDefaultFalseFeedbackMsg;

      return (
        <div
          className={
            "exercisePlugin fillinblankPlugin" +
            (attempted ? " attempted " : " ") +
            (props.exercises.showFeedback ? "showFeedback" : "")
          }
        >
          <div className={"row"} key={0}>
            <div className={"col-xs-12"}>
              <VisorPluginPlaceholder
                {...props}
                key="0"
                pluginContainer={"Question"}
                isFibQuestion
              />
            </div>
          </div>
          {istrue && !checkEmptyTrueFeedback ? (
            <div
              className={"row feedbackRow"}
              key={-2}
              style={{ display: showFeedback ? "block" : "none" }}
            >
              <div
                className={"col-xs-12 feedback"}
                role="status"
                aria-live="polite"
                style={{
                  color: /* quizColor */ "black",
                  borderColor: "#318533",
                  backgroundColor: setRgbaAlpha("rgba(39,208,124,0.20)", 0.15),
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <VisorPluginPlaceholder {...props} key="0" pluginContainer={"TrueFeedback"} />
              </div>
            </div>
          ) : null}
          {!istrue && !checkEmptyFalseFeedback ? (
            <div
              className={"row feedbackRow"}
              key={-2}
              style={{ display: showFeedback ? "block" : "none" }}
            >
              <div
                className={"col-xs-12 feedback"}
                role="status"
                aria-live="polite"
                style={{
                  color: /* quizColor */ "black",
                  borderColor: "#a31111",
                  backgroundColor: setRgbaAlpha("rgba(213,26,26,0.20)", 0.15),
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <VisorPluginPlaceholder {...props} key="1232" pluginContainer={"FalseFeedback"} />
              </div>
            </div>
          ) : null}
          {isTryAgainMode && !state.showFeedback ? (
            <QuizStatusLine correct={istrue} visible={attempted && answered} />
          ) : null}
          <div className={"exerciseScore"}>{score}</div>
          <div className={"row"} key={7}>
            <button
              onClick={(e) => {
                this.refreshAnswers();
                props.tryAgainHandler();
              }}
              style={{
                display:
                  istrue ||
                  !props.exercises.attempted ||
                  (state.buttons != "tryAgain" &&
                    state.buttons != i18n.t("MultipleChoice.tryAgain") &&
                    state.buttons != "Try Again" &&
                    state.buttons != "Tekrar Dene")
                    ? "none"
                    : "inline",
              }}
              className={"tryButton"}
            >
              {i18n.t("MultipleChoice.tryAgain")}
            </button>
            <button
              onClick={(e) => {
                this.seeAnswer(props.exercises.correctAnswer);
                props.seeAnswerHandler();
              }}
              style={{
                display:
                  istrue ||
                  !props.exercises.attempted ||
                  (state.buttons != i18n.t("MultipleChoice.seeAnswer") &&
                    state.buttons != "seeAnswer")
                    ? "none"
                    : "inline",
              }}
              className={"tryButton"}
            >
              {i18n.t("MultipleChoice.seeAnswer")}
            </button>
            <button
              onClick={(e) => {
                this.checkButtonHandler(props, isTryAgainMode);
                props.submitPage(props.currentView, props.id);
              }}
              style={{ display: props.exercises.attempted ? "none" : "inline" }}
              className={"tryButton"}
            >
              {i18n.t("MultipleChoice.checkAnswer")}
            </button>
          </div>
        </div>
      );
    },
    checkAnswer(current, correct, state) {
      // Accent/case-insensitive, "//" alternates, no zero-blank auto-pass
      // (scoring bug #5). With "Kısmi puan" on, score the fraction of correctly
      // filled blanks; otherwise every blank is required (all-or-nothing).
      return correctFillInBlank(current, correct, state?.allowPartialScore);
    },
    refreshAnswers(props) {
      let inputs = document.getElementsByClassName("fibinput");

      Array.prototype.forEach.call(inputs, (input) => {
        input.value = "";
        input.style.border = "1px solid black";
      });
    },
    checkButtonHandler(props, isTryAgainMode) {
      let inputs = document.getElementsByClassName("fibinput");

      Array.prototype.forEach.call(inputs, (input) => {
        // Tekrar modunda input'ları boyama; nötr bırak (cevap açığa çıkmasın).
        if (isTryAgainMode) {
          input.style.border = "1px solid black";
          return;
        }
        let id = input.id.replace("fib-", "");

        let condition =
          props.exercises.correctAnswer !== undefined &&
          props.exercises.correctAnswer.length !== undefined &&
          props.exercises.currentAnswer !== undefined &&
          props.exercises.currentAnswer.length !== undefined;

        const correct = condition ? props.exercises.correctAnswer[id] : undefined;
        const current = condition ? props.exercises.currentAnswer[id] : undefined;
        if (
          correct != null &&
          current != null &&
          correct.trim().toLocaleUpperCase(i18n.language) ===
            current.trim().toLocaleUpperCase(i18n.language)
        ) {
          input.style.border = "2px solid green";
        } else {
          input.style.border = "2px solid red";
        }
      });
    },
    seeAnswer(correctAnswers) {
      let inputs = document.getElementsByClassName("fibinput");

      Array.prototype.forEach.call(inputs, (input, index) => {
        input.value = correctAnswers[index];
        input.style.border = "1px solid black";
      });
    },
  };
}
/* eslint-enable react/prop-types */
